module.exports = __webpack_public_path__ + "static/img/blog-comment.07c74a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog-comment.jpg
// module id = Quc0
// module chunks = 36